import { makeStyles, tokens } from '@fluentui/react-components';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { AppSidebar } from './AppSidebar';
import { ChatBubble } from '../features/assistant/ChatBubble';

const useStyles = makeStyles({
  root: { display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: tokens.colorNeutralBackground1 },
  body: { display: 'flex', flex: 1, minHeight: 0 },
  main: { flex: 1, overflowY: 'auto', padding: tokens.spacingHorizontalL },
});

export const AppLayout = () => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <AppHeader />
      <div className={styles.body}>
        <AppSidebar />
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
      <ChatBubble />
    </div>
  );
};
